import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-location-dm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-location-dm.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import Polygon from "@arcgis/core/geometry/Polygon";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ViewLocationDmConstants } from "./view-location-dm.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewLocationDmComponent = class ViewLocationDmComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    descriptionLabel1 = ViewLocationDmConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewLocationDmConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewLocationDmConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewLocationDmConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewLocationDmConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewLocationDmConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewLocationDmConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewLocationDmConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewLocationDmConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewLocationDmConstants.SG_CODE_CONTROL;
    addressControl = ViewLocationDmConstants.ADDRESS_CONTROL;
    ownerControl = ViewLocationDmConstants.OWNER_CONTROL;
    cadastralDescriptionControl = ViewLocationDmConstants.CADASTRAL_DESCRIPTION_CONTROL;
    rateNumberControl = ViewLocationDmConstants.RATE_NUMBER_CONTROL;
    existingUseControl = ViewLocationDmConstants.EXISTING_USE_CONTROL;
    worthyOfPreservationControl = ViewLocationDmConstants.WORTHY_OF_PRESERVATION_CONTROL;
    reasonControl = ViewLocationDmConstants.REASON_CONTROL;
    over60Control = ViewLocationDmConstants.OVER_60_CONTROL;
    amafaPermissionControl = ViewLocationDmConstants.AMAFA_PERMISSION_CONTROL;
    erfNoTextPlaceHolder = ViewLocationDmConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewLocationDmConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewLocationDmConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewLocationDmConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewLocationDmConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewLocationDmConstants.ADDRESS_TEXT_PLACEHOLDER;
    cadastralDescriptionTextPlaceHolder = ViewLocationDmConstants.CADASTRAL_DESCRIPTION_TEXT_PLACEHOLDER;
    rateNumberTextPlaceHolder = ViewLocationDmConstants.RATE_NUMBER_TEXT_PLACEHOLDER;
    existingUseTextPlaceHolder = ViewLocationDmConstants.EXISTING_USE_TEXT_PLACEHOLDER;
    worthyOfPreservationTextPlaceHolder = ViewLocationDmConstants.WORTHY_OF_PRESERVATION_TEXT_PLACEHOLDER;
    reasonTextPlaceHolder = ViewLocationDmConstants.REASON_TEXT_PLACEHOLDER;
    over60TextPlaceHolder = ViewLocationDmConstants.OVER_60_TEXT_PLACEHOLDER;
    amafaPermissionTextPlaceHolder = ViewLocationDmConstants.AMAFA_PERMISSION_TEXT_PLACEHOLDER;
    ownerLabel = ViewLocationDmConstants.OWNER_LABEL;
    removePropertyLabel = ViewLocationDmConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = true;
    ownerDisableEditing = true;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    mapComponent;
    isMapLoaded = false;
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    dmApplication;
    propertyFieldSetup = {};
    selectedApplicationDMSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
        if (stepMeta && stepMeta.propertyFieldSetup) {
            this.propertyFieldSetup = stepMeta.propertyFieldSetup;
        }
    }
    isPropertyFieldVisible(fieldName) {
        const fieldOptions = this.propertyFieldSetup?.[fieldName];
        return fieldOptions?.visible !== false;
    }
    isPropertyFieldRequired(fieldName) {
        const fieldOptions = this.propertyFieldSetup?.[fieldName];
        return fieldOptions?.required === true;
    }
    handleRouteChange() {
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.checkSave();
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    checkSave() {
        this.selectedApplicationDMSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            ;
            this.dmApplication = app;
            if (this.dmApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber, [Validators.required]),
            subdivision: new FormControl(prop.subdivision, [Validators.required]),
            allotment: new FormControl(prop.allotment, [Validators.required]),
            farmNo: new FormControl(prop.farmNumber, [Validators.required]),
            sgCode: new FormControl(prop.sgCode, [Validators.required]),
            address: new FormControl(prop.address, [Validators.required]),
            cadastralDescription: new FormControl(prop.cadastralDescription, [Validators.required]),
            rateNumber: new FormControl(prop.rateNumber, [Validators.required]),
            existingUse: new FormControl(prop.existingUse, [Validators.required]),
            worthyOfPreservation: new FormControl(prop.worthyOfPreservation, [Validators.required]),
            reason: new FormControl(prop.reason, [Validators.required]),
            over60: new FormControl(prop.over60, [Validators.required]),
            amafaPermission: new FormControl(prop.amafaPermission),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geom)
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.dmApplication.properties && this.dmApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geom));
        return propertyFoemGroup;
    }
    syncMapExistingGeometries() {
        const pa = this.getProperties();
        while (pa.controls.length > 0) {
            pa.removeAt(0);
        }
        this.dmApplication.properties.forEach((prop) => {
            pa.push(this.singleFg(prop));
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, ViewLocationDmConstants.PROPERTY_LAYER_NAME, true);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewLocationDmComponent = __decorate([
    Component({
        selector: "app-view-location-dm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewLocationDmComponent);
export { ViewLocationDmComponent };
